import React, { useEffect, useState } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Label } from 'recharts';


const DonutChart = (data) => {
    const setData = (isHigh) => {
        if (isHigh) {
            const maxValue = Math.max(...data.data.map(val => val.value));
            return data.data.find(item => item.value === maxValue);
        } else {
            const minValue = Math.min(...data.data.map(val => val.value));
            return data.data.find(item => item.value === minValue);
        }
    }

    const [highData, setHighData] = useState(setData(true));
    const [lowData, setLowData] = useState(setData(false));

    // To render central part of chart.
    const renderCustomizedLabel = ({ viewBox }) => {
        const { cx, cy } = viewBox;
        return (
            <g>
                <text x={cx} y={cy - 30} textAnchor="middle" dominantBaseline="central" className='fill-teal-200 text-2xl font-bold'>
                    {highData?.value}
                </text>
                <text x={cx} y={cy - 10} textAnchor="middle" dominantBaseline="central" className='fill-teal-200 text-xs'>
                    {highData?.name}
                </text>
                <line x1={cx - 30} y1={cy + 5} x2={cx + 30} y2={cy + 5} className='text-teal-200' style={{ stroke: '#333', strokeWidth: 1 }} />
                <text x={cx} y={cy + 15} textAnchor="middle" dominantBaseline="central" className='fill-teal-100 text-xs'>
                    {lowData?.name}
                </text>
                <text x={cx} y={cy + 35} textAnchor="middle" dominantBaseline="central" className='fill-teal-100 text-2xl font-bold'>
                    {lowData?.value}
                </text>
            </g>
        );
    };

    return (
        <ResponsiveContainer  width="100%" height="100%">
            <PieChart className="h-max">
                <Pie
                    data={data.data}
                    innerRadius={67}
                    outerRadius={85}
                    startAngle={90}
                    endAngle={450}
                    paddingAngle={5}
                    cornerRadius={10}
                    dataKey="value"
                >
                    {data.data.sort((a, b) => b.value - a.value).map((entry, index) => {
                        const thickness = index * 10;

                        return (
                            <Cell
                                key={`cell-${index}`}
                                className={`
                                ${entry.value === highData?.value 
                                    ? 'fill-teal-200' 
                                    : 'fill-teal-100'} 
                                stroke-gray-20`}
                                strokeWidth={thickness}
                            />
                        )
                    }
                    )}
                    <Label content={renderCustomizedLabel} />
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    )
};

export default DonutChart;
